export const importanceList = {
    null: {
        importance: null,
        name: "title",
        colorName: "",
        color: "#FFF",
        analyticColor: "#C8D7E4",
        pulseColor: "#FFF",
        mapFillColor: "#C8D7E4",
        textColor: "#7b87a5"
    },
    0: {
        importance: 0,
        name: "title",
        colorName: "",
        color: "#FFF",
        analyticColor: "#C8D7E4",
        pulseColor: "#fff",
        mapFillColor: "#C8D7E4",
        textColor: "#7b87a5"
    },
    1: {
        importance: 1,
        name: "not_critical",
        colorName: "green",
        color: "#AFE669",
        analyticColor: "#C4F487",
        pulseColor: "#C7EEA6",
        mapFillColor: "#B9DD9B",
        textColor: "#373D3F"
    },
    2: {
        importance: 2,
        name: "moderately",
        colorName: "yellow",
        color: "#FFDC1B",
        analyticColor: "#FFE767",
        pulseColor: "#FFF4B4",
        mapFillColor: "#FBF0B4",
        textColor: "#373D3F"
    },
    3: {
        importance: 3,
        name: "important",
        colorName: "orange",
        color: "#FFA17E",
        analyticColor: "#FF9067",
        pulseColor: "#FFC499",
        mapFillColor: "#FFB795",
        textColor: "#fff"
    },
    4: {
        importance: 4,
        name: "critical",
        colorName: "red",
        color: "#FA5C5C",
        analyticColor: "#FA665C",
        pulseColor: "#FFA099",
        mapFillColor: "#F7776F",
        textColor: "#fff"
    },
};